import React from "react";

export default function BenchmarkInsights({ insights = [] }) {
  if (!insights.length) {
    return (
      <p style={{ color: "#6b7280", fontSize: "0.85rem", margin: 0 }}>
        No insights yet — add more KPI data to unlock gap analysis recommendations.
      </p>
    );
  }

  return (
    <div className="insight-list">
      {insights.map((item, idx) => (
        <div key={`${item.title}-${idx}`} className={`insight-card ${item.type || ""}`}>
          <h4>{item.title}</h4>
          <p>{item.text}</p>
        </div>
      ))}
    </div>
  );
}
